import { JOBS_PUBLIC_ENDPOINT } from 'src/constants';
import { getAuthenticatedUser, getTokenFromAuthenticatedUser } from 'src/features/login';
import { getMandatoryEnvVar } from 'src/utils/env';
import { errorToJson } from 'src/utils/error';
import { FormState } from '../types/Form';

export interface CloseJobFormData extends FormState {
    jobId: string;
}

export interface CloseJobResponse {
    message: string;
}

const API_BASE_URL = getMandatoryEnvVar('REACT_APP_API_BASE_URL');

export const closeJob = async (formData: CloseJobFormData): Promise<CloseJobResponse> => {
    const user = await getAuthenticatedUser();
    const token = getTokenFromAuthenticatedUser(user);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
    };

    try {
        const response = await fetch(
            `${API_BASE_URL}/${JOBS_PUBLIC_ENDPOINT}/v1/jobs/close`,
            requestOptions
        );
        const data = await response.json();

        if (!response.ok) {
            const error = (data && data.message) || response.status;
            throw new Error(error);
        }

        return data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to complete job', {
            errorStringified: JSON.stringify(errorToJson(error)),
            error: errorToJson(error),
        });
        throw new Error('Failed to complete job');
    }
};
